import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Modal, TouchableWithoutFeedback } from 'react-native';

export type FilterOption = 'All' | 'Active' | 'In Conversation' | 'Pending' | 'Inactive';

interface ChannelFilterDropdownProps {
    visible: boolean;
    onClose: () => void;
    selectedFilter: FilterOption;
    onSelect: (filter: FilterOption) => void;
    anchor: { top: number; right: number };
}

const options: { label: FilterOption; color: string }[] = [
    { label: 'All', color: '#E5E5E5' },
    { label: 'Active', color: '#4CAF50' },
    { label: 'In Conversation', color: '#7B61FF' },
    { label: 'Pending', color: '#FFD700' },
    { label: 'Inactive', color: '#D3D3D3' },
];

export const ChannelFilterDropdown = ({ visible, onClose, selectedFilter, onSelect, anchor }: ChannelFilterDropdownProps) => {
    return (
        <Modal
            transparent
            visible={visible}
            animationType="fade"
            onRequestClose={onClose}
        >
            <TouchableWithoutFeedback onPress={onClose}>
                <View style={styles.overlay}>
                    <View style={[styles.dropdownContainer, { top: anchor.top, right: anchor.right }]}>
                        {options.map((option) => (
                            <TouchableOpacity
                                key={option.label}
                                style={[
                                    styles.option,
                                    selectedFilter === option.label && styles.selectedOption
                                ]}
                                onPress={() => {
                                    onSelect(option.label);
                                    onClose();
                                }}
                            >
                                <View style={[styles.colorDot, { backgroundColor: option.color }]} />
                                <Text style={[
                                    styles.optionText,
                                    selectedFilter === option.label && styles.selectedOptionText
                                ]}>
                                    {option.label}
                                </Text>
                            </TouchableOpacity>
                        ))}
                    </View>
                </View>
            </TouchableWithoutFeedback>
        </Modal>
    );
};

const styles = StyleSheet.create({
    overlay: {
        flex: 1,
        backgroundColor: 'transparent',
    },
    dropdownContainer: {
        position: 'absolute',
        backgroundColor: 'white',
        borderRadius: 12,
        padding: 8,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.1,
        shadowRadius: 12,
        elevation: 5,
        minWidth: 180,
        borderWidth: 1,
        borderColor: '#F3F4F6',
    },
    option: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: 10,
        paddingHorizontal: 12,
        borderRadius: 20,
        marginBottom: 4,
    },
    selectedOption: {
        backgroundColor: '#E0F2FE',
        borderWidth: 1,
        borderColor: '#0EA5E9',
    },
    colorDot: {
        width: 12,
        height: 12,
        borderRadius: 6,
        marginRight: 10,
    },
    optionText: {
        fontSize: 13,
        fontWeight: '600',
        color: '#4B5563',
    },
    selectedOptionText: {
        color: '#0369A1',
    },
});
